exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".debitcard-text[data-v-67439454] {\n  padding-bottom: 15px;\n}", ""]);

// exports
